import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import PageHeader from '../../components/common/PageHeader';
import { schoolDivisions } from '../../data/schoolInfo';
import collegeImg from '../../assets/college.jpg';

const OurSchools = () => {
  const schools = [
    {
      ...schoolDivisions.montessori,
      image: 'https://images.unsplash.com/photo-1587654780291-39c9404d746b?w=800&h=600&fit=crop',
      fullDescription: 'Our Montessori and Primary division provides a nurturing environment where young learners develop a love for learning through hands-on experiences and individualized instruction.',
    },
    {
      ...schoolDivisions.college,
      image: collegeImg,
      fullDescription: 'Stirret College prepares students for academic excellence and life beyond school through rigorous academics, character development, and diverse extracurricular opportunities.',
    },
  ];

  return (
    <>
      <PageHeader
        title="Our Schools"
        subtitle="Two divisions united by one vision - raising exceptional leaders"
        breadcrumbs={[{ label: 'Our Schools' }]}
      />

      <section className="section-padding bg-white">
        <div className="container-custom">
          {schools.map((school, index) => (
            <motion.div
              key={school.shortName}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className={`grid lg:grid-cols-2 gap-12 items-center ${
                index !== schools.length - 1 ? 'mb-20 pb-20 border-b border-gray-100' : ''
              }`}
            >
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <span className="inline-block px-4 py-1 bg-primary-100 text-primary-600 rounded-full text-sm font-medium mb-4">
                  {school.ageRange}
                </span>
                <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-4">
                  {school.name}
                </h2>
                <p className="text-xl text-primary-600 font-medium mb-4">{school.tagline}</p>
                <p className="text-gray-600 leading-relaxed mb-6">{school.fullDescription}</p>

                <ul className="space-y-3 mb-8">
                  {school.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-3 text-gray-700">
                      <CheckCircle2 className="text-primary-600 flex-shrink-0" size={20} />
                      {feature}
                    </li>
                  ))}
                </ul>

                <Link to={school.href} className="btn-primary group inline-flex">
                  Learn More
                  <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
                </Link>
              </div>

              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <img
                  src={school.image}
                  alt={school.shortName}
                  className="w-full h-[400px] object-cover rounded-2xl shadow-hard"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </>
  );
};

export default OurSchools;
